import imgs from '@/config/randomImgs'
import randomNumber from '~/utils/randomNumber'

export default function () {
  const imgId = imgs[randomNumber(0, imgs.length - 1)]

  return `https://images.unsplash.com/photo-${imgId}?q=80`
}
